export default {
  getOrigin(state) {
    return state.origin;
  },
  getOrigins(state) {
    return state.origins;
  },
  getOriginSelected(state) {
    return state.originSelected;
  },
  getActiveOrigins(state) {
    return state.origins ? state.origins.filter((o) => o.active) : null;
  },
  getActiveCustomOrigins(state) {
    return state.origins ? state.origins.filter((o) => o.active && !o.default) : null;
  },
};
